import "./NursingCareProviderNetanyaWithinFiveHours.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import LocationsAndPavilionsInNetanya from "./sections/LocationsAndPavilionsInNetanya";
import NursingServices from "./sections/NursingServices";
import FaqSection from "./sections/FaqSection";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function NursingCareProviderNetanyaWithinFiveHoursPage() {
  return <div>
      <Header />
      <HeroSection />
      <LocationsAndPavilionsInNetanya />
      <NursingServices />
      <FaqSection />
      <FinalCallToAction />
      <Footer />
    </div>;
}